<route-meta>
{
  "requiresAuth": true
}
</route-meta>

<template>
  <div class="extension detail">
    <template v-if="componentExists(`detail${objectType}`)">
      <component :is="`detail${objectType}`"></component>
    </template>
    <template v-else>
      <header class="detail__header">
        <router-link
          :to="{ name: gridName }"
          class="btn-back"
        >
          <font-awesome-icon icon="chevron-left" />
        </router-link>
        <h1 v-if="object._id">{{ object._id }}</h1>
        <button
          @click="save"
          class="btn btn-success btn--save"
        >
          {{ $t('general.update') }}
        </button>
      </header>

      <div class="extension__form">
        <div class="panel">
          <div class="panel__body">
            <extension-form
              :fields="fields"
              :object="object"
            ></extension-form>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ExtensionForm from './form';
import { mapState } from 'vuex';
import detailwebsite from '../../website/_id';
import { validate } from '@/helpers/validation';

export default {
  name: 'objects-id',
  components: {
    ExtensionForm,
    detailwebsite,
  },
  computed: {
    objectType() {
      return this.$route.params.type;
    },
    fields() {
      /* eslint-disable */
      return this.$store.getters['fields/getTypeFields'](this.objectType);
      /* eslint-enable */
    },
    ...mapState({
      entries: state => state.objects.entries,
    }),
    gridName() {
      return `${this.entity}-type-index`;
    },
  },
  data() {
    return {
      object: {},
      entity: 'objects',
    };
  },
  methods: {
    submit() {
      // Validate before submit
      // @todo: centralize
      const validation = validate(this.fields, this.object);
      if (!validation.valid) {
        validation.errors.forEach(error => {
          this.$error(error);
        });
        return false;
      }

      this.$store.dispatch(`${this.entity}/update`, {
        object: {
          _id: this.object._id,
          body: JSON.parse(JSON.stringify(this.object)),
          object_type: this.objectType,
        },
        callback: () => {
          this.$success(this.$t('general.messages.update.success'));
        },
      });
    },
    getFilekeys() {
      const filekeys = [];
      if (this.object) {
        Object.keys(this.object).forEach(key => {
          const value = this.object[key];
          if (value.lastModified) {
            filekeys.push(key);
          }
        });
      }
      return filekeys;
    },
    save() {
      // List all keys containing files
      const filekeys = this.getFilekeys();

      // There are no files - submit as is
      if (filekeys.length === 0) {
        this.submit();
      }

      // Analytics
      this.$ga.event('object', 'update', `${this.objectType}`);

      let uploaded = 0;
      filekeys.forEach(key => {
        const value = this.object[key];
        // Value is file, upload it and change the value for link
        const formData = new FormData();
        formData.append('file', value);
        formData.append('filepath', `assets/pdf/${value.name}`);

        this.$http
          .post('/filesystem/upload', formData, {
            headers: {
              accept: 'application/json',
              'Accept-Language': 'en-US,en;q=0.8',
              'Content-Type': `multipart/form-data; boundary=${
                formData._boundary
              }`,
            },
          })
          .then(data => {
            this.object[key] = data.data;
            uploaded = uploaded + 1;

            // All files were uploaded, submit
            if (uploaded === filekeys.length) {
              this.submit();
            }
          });
      });
    },
  },
  created() {
    this.$store.dispatch('objects/get');
    this.$store.dispatch('fields/get');
  },
  watch: {
    entries(value) {
      if (value.length === 0) {
        return true;
      }
      const found = value.find(({ _id }) => _id === this.$route.params.id);
      if (typeof found !== 'undefined') {
        this.object = JSON.parse(JSON.stringify(found));
      }
    },
  },
};
</script>
